import { render, staticRenderFns } from "./StaffGroups.vue?vue&type=template&id=f662379c&"
import script from "./StaffGroups.vue?vue&type=script&lang=js&"
export * from "./StaffGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports